import { trackFullStoryEvent } from 'helpers/fullstory';

import {
  MARK_WALKTHROUGH_EVENT,
  type MarkWalkthroughCompletionType,
  type MarkWalkthroughDismissMethod,
  type MarkWalkthroughEntryPoint,
  type MarkWalkthroughPath,
  type MarkWalkthroughSection,
} from './mark-walkthrough-analytics.constants';

export const trackMarkWalkthroughStarted = (
  entryPoint: MarkWalkthroughEntryPoint
): void => {
  trackFullStoryEvent(MARK_WALKTHROUGH_EVENT.started, {
    section: 'walkthroughModal',
    entryPoint,
  });
};

interface MarkWalkthroughViewedProps {
  section: MarkWalkthroughSection;
  stepNumber?: number;
  stepId?: string;
}

export const trackMarkWalkthroughViewed = ({
  section,
  stepNumber,
  stepId,
}: MarkWalkthroughViewedProps): void => {
  trackFullStoryEvent(MARK_WALKTHROUGH_EVENT.viewed, {
    section,
    ...(stepNumber !== undefined && { stepNumber }),
    ...(stepId && { stepId }),
  });
};

interface MarkWalkthroughDismissedProps {
  section: MarkWalkthroughSection;
  dismissMethod: MarkWalkthroughDismissMethod;
  stepNumber?: number;
}

export const trackMarkWalkthroughDismissed = ({
  section,
  dismissMethod,
  stepNumber,
}: MarkWalkthroughDismissedProps): void => {
  trackFullStoryEvent(MARK_WALKTHROUGH_EVENT.dismissed, {
    section,
    dismissMethod,
    ...(stepNumber !== undefined && { stepNumber }),
  });
};

interface MarkWalkthroughPathSelectedProps {
  path: MarkWalkthroughPath;
  exampleLabel?: string;
  entryPoint?: MarkWalkthroughEntryPoint;
}

export const trackMarkWalkthroughPathSelected = ({
  path,
  exampleLabel,
  entryPoint,
}: MarkWalkthroughPathSelectedProps): void => {
  trackFullStoryEvent(MARK_WALKTHROUGH_EVENT.pathSelected, {
    section: 'walkthroughModal',
    path,
    ...(exampleLabel && { exampleLabel }),
    ...(entryPoint && { entryPoint }),
  });
};

interface MarkWalkthroughCompletedProps {
  section: MarkWalkthroughSection;
  completionType: MarkWalkthroughCompletionType;
  exampleLabel?: string;
  entryPoint?: MarkWalkthroughEntryPoint;
}

export const trackMarkWalkthroughCompleted = ({
  section,
  completionType,
  exampleLabel,
  entryPoint,
}: MarkWalkthroughCompletedProps): void => {
  trackFullStoryEvent(MARK_WALKTHROUGH_EVENT.completed, {
    section,
    completionType,
    ...(exampleLabel && { exampleLabel }),
    ...(entryPoint && { entryPoint }),
  });
};
